module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08aceb12","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/map/OutMap.vue
// module id = 780
// module chunks = 0